import { httpReducer, reduceReducers } from "../lib/create-action";
import {
  distributionsDistributeActionName,
  distributionsFetchActionName,
  distributionsPutActionName,
} from "../action_managers/distributions";
import get from "lodash/get";
import mapValues from "lodash/mapValues";

const distributionsFetchReducer = httpReducer(
  distributionsFetchActionName,
  {
    isLoading: false,
    distributions: {},
  },
  {
    success: (state, action) => {
      var distributions = get(action, "payload.resp.links");
      var showUUID = get(action, "payload.resp.showUUID");
      if (distributions && showUUID) {
        state = Object.assign({}, state, {
          distributions: { ...state.distributions, [showUUID]: distributions },
        });
      }
      return state;
    },
  }
);

const distributionsPutReducer = httpReducer(
  distributionsPutActionName,
  {
    isPutting: false,
    distributions: {},
    validationErrors: [],
  },
  {
    success: (state, action) => {
      var distributions = get(action, "payload.resp.links");
      var showUUID = get(action, "payload.resp.showUUID");
      if (distributions && showUUID) {
        state = Object.assign({}, state, {
          distributions: { ...state.distributions, [showUUID]: distributions },
          validationErrors: [],
        });
      }
      return state;
    },
    failureBadRequest: (state, action) => {
      return Object.assign({}, state, {
        validationErrors: get(action, "payload.validationErrors"),
      });
    },
  },
  {
    loadingKeyName: "isPutting",
  }
);

const distributionDistributeReducer = httpReducer(
  distributionsDistributeActionName,
  {
    isPutting: false,
    distributions: {},
    validationErrors: [],
  },
  {
    success: (state, action) => {
      const showUUID = action.payload.body.showUUID;
      return {
        ...state,
        distributions: {
          ...state.distributions,
          [showUUID]: {
            ...state.distributions[showUUID],
            ...mapValues(action.payload.resp, val => {
              return val.deepLink;
            }),
          },
        },
      };
    },
  }
);

export default reduceReducers(
  distributionsFetchReducer,
  distributionsPutReducer,
  distributionDistributeReducer
);
